import React, { useEffect } from 'react'
import {
  IBuffetDishWithImplInfoDto,
  IPredictDataDto,
} from '../../../../../core/api/dto/BuffetDishDto'
import { useAppSelector } from '../../../../../core/store/store'

interface UseAiAssistantModeProps {
  predictionData: IPredictDataDto | null
  isOpenPopup: boolean
  setIsOpenPopup: React.Dispatch<
    React.SetStateAction<IBuffetDishWithImplInfoDto | null>
  >
}

export const useAiAssistantMode = ({
  predictionData,
  setIsOpenPopup,
  isOpenPopup,
}: UseAiAssistantModeProps) => {
  const { aiAssistantMode, aiAssistantPercent } = useAppSelector(
    (state) => state.options,
  )
  useEffect(() => {
    if (aiAssistantMode && predictionData?.results && !isOpenPopup) {
      const find = predictionData?.results.find(
        (item) => item.accuracy >= aiAssistantPercent,
      )
      if (find) {
        const dish: IBuffetDishWithImplInfoDto =
          find.dish as unknown as IBuffetDishWithImplInfoDto
        setIsOpenPopup(dish)
      }
    }
    // eslint-disable-next-line
  }, [aiAssistantMode, predictionData, aiAssistantPercent])
}
